import type { IconAsset } from '../Icon.types';

const code = (
  <g transform='translate(-734 -161)'>
    <rect height='24' opacity='0' transform='translate(734 161)' width='24' />
    <g transform='translate(733.249 164)'>
      <path
        d='M15.533,1.5a6.03,6.03,0,0,1,6.033,6.149c0,3.647-5.443,9.289-5.674,9.528a.5.5,0,0,1-.717,0C14.943,16.938,9.5,11.3,9.5,7.649A6.03,6.03,0,0,1,15.533,1.5Zm0,14.6c.5-.541,1.439-1.6,2.372-2.858,1.741-2.341,2.661-4.274,2.661-5.59a5.034,5.034,0,1,0-10.066,0c0,1.317.922,3.253,2.668,5.6C14.1,14.5,15.037,15.558,15.533,16.1Z'
        fill='currentColor'
        transform='translate(-3.249)'
      />
      <path
        d='M2.785-.5A3.285,3.285,0,1,1-.5,2.785,3.289,3.289,0,0,1,2.785-.5Zm0,5.571A2.285,2.285,0,1,0,.5,2.785,2.288,2.288,0,0,0,2.785,5.071Z'
        fill='currentColor'
        transform='translate(9.499 4.862)'
      />
    </g>
  </g>
);

export const locationOutline: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
